<div class="form-item">
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="items-area" [class.disabled]="isLoading">
    <div class="item">
      <div class="mb-7">Payment Methods</div>
      <div>
        <div class="chekt-select-option-wrapper" #paymentMethodsSelectDropdown>
          <div class="chekt-select-option" style="z-index:2">
            <div class="chekt-select-option-label" (click)="isUnfoldPaymetMethodsList = !isUnfoldPaymetMethodsList">
              <div *ngIf="!paymentMethod" style="color:#a3acb9;">Select payment methods</div>
              <div>{{paymentMethod}}</div>
            </div>
            <div class="chekt-select-option-icon">
              <div class="my-icon" style="font-size: 18px;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                  <path d="M0 0h24v24H0V0z" fill="none"></path>
                  <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="chekt-select-dropdown" *ngIf="isUnfoldPaymetMethodsList">
            <div class="select-option-modal-list">
              <div class="chekt-select-dropdown-list" *ngFor="let method of paymetMethodsList" (click)="selectMethod(method)">
                <div>{{method}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="paymentMethod === 'Credit or Debit card'">
      <ng-container *ngIf="!cardAccounts.length || isCreatingCreditCardAccount">
        <div class="item">
          <div class="mb-7">Card number</div>
          <div><span style="position: absolute; margin-left: 8px">
              <div *ngIf="cardType == 'visa'" style="height: 34px;"><img src="/assets/logo/visa.svg" alt="VISA Card" style="width:40px; height:34px;"/></div>
              <div *ngIf="cardType == 'mastercard'" style="height: 34px;"><img src="/assets/logo/mastercard.svg" alt="Mastercard" style="width:40px; height:34px;"/></div>
              <div *ngIf="cardType == 'amex'" style="height: 34px;"><img src="/assets/logo/american-express.svg" alt="American Express" style="width:40px; height:34px;"/></div>
              <div *ngIf="cardType == 'genric'">
                <div style="border-radius: 2px; background-color: #E3E8EE; width: 33px; height: 25px; margin: 4px 0 0 2px">
                  <div style="position: absolute; background-color: #8792A2; top: 10px; width: 33px; height: 8px;"></div>
                </div>
              </div></span>
            <input type="tel" inputmode="numeric" pattern="/^d{0,16}$/g" style="padding-left: 46px; width: 304px" autocomplete="cc-number" maxlength="19" placeholder="Card Number" [class.invalid]="errorString.cardNumber.length" (input)="onInputCCNumberHandler($event)" (keydown)="onKeydownCCNumberHandler($event)" [(ngModel)]="newCardInfo.cardnumber"/>
            <div class="error" *ngIf="errorString.cardNumber.length">{{errorString.cardNumber}}</div>
          </div>
        </div>
        <div class="item" style="width: 360px; display: flex;">
          <div style="margin-right: 16px">
            <div class="mb-7">Expiration date</div>
            <div>
              <input style="width: 90%" autocomplete="off" type="text" pattern="/^d{0,4}$/g" maxlength="5" placeholder="MM/YY" [class.invalid]="errorString.expirDate.length" (keydown)="onKeyDownExpiryHandler($event)" (input)="onInputExpiryHandler($event)" [(ngModel)]="newCardInfo.exp"/>
              <div class="error" *ngIf="errorString.expirDate.length">{{errorString.expirDate}}</div>
            </div>
          </div>
          <div>
            <div class="mb-7">
              <div class="flex"><span class="mr-7">CVC</span>
                <div class="tooltip-content v-center">
                  <comp-icon class="pointer" [icon]="'info'" [size]="18"></comp-icon>
                  <div class="tooltip">
                    <div class="flex">
                      <div class="f-1">
                        <div class="small-font">Visa, Mastercaed and Diners</div>
                        <div class="card-box visa">
                          <div class="card-magnetic"></div>
                          <div class="card-cvc-holder"><span class="holder-number mr-14">0123456789</span>
                            <div class="relative"><span class="cvc">123</span>
                              <div class="indicator">
                                <div class="horiz-line"></div>
                                <div class="vertical-line"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>There is a 3-digit code in the upper right corner of the signature box on the back of the card.</div>
                      </div>
                      <div style="width: 20px; height:1px;"></div>
                      <div class="f-1">
                        <div class="small-font">American Express</div>
                        <div class="card-box amex">
                          <div class="ic-chip"></div>
                          <div class="card-number-box">
                            <div class="card-number-area">
                              <div class="card-cvc-holder">
                                <div class="relative">
                                  <div class="cvc">1234</div>
                                  <div class="indicator">
                                    <div class="horiz-line"></div>
                                    <div class="vertical-line height-62"></div>
                                  </div>
                                </div>
                              </div>
                              <div style="width:fit-content">3132 123456 12345</div>
                            </div>
                          </div>
                        </div>
                        <div>There is a 4-digit number printed above the account number on the front of the card.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <input style="width: 100%" autocomplete="off" type="text" pattern="/^d{0,3}$/g" maxlength="4" [class.invalid]="errorString.cvc.length" (keypress)="validate($event)" (input)="onInputCVC($event)" [(ngModel)]="newCardInfo.CVC"/>
              <div class="error" *ngIf="errorString.cvc.length">{{errorString.cvc}}</div>
            </div>
          </div>
        </div>
        <div class="mb-7 cursor-pointer" style="display: flex; align-items: center;" (click)="isShowOption = !isShowOption">
          <div><i class="material-icons" *ngIf="!isShowOption" style="font-size: 20px; color: #2383e2">expand_more</i><i class="material-icons" *ngIf="isShowOption" style="font-size: 20px; color: #2383e2">expand_less</i></div>
          <div style="font-weight:500; color:#2383e2">More Option</div>
        </div>
        <div *ngIf="isShowOption">
          <div class="item">
            <div class="mb-7">Account holder name</div>
            <div>
              <input autocomplete="off" type="text" [(ngModel)]="newCardInfo.nickname" (input)="onInputNickName()"/>
            </div>
          </div>
          <div class="item">
            <div class="mb-7">Card Address</div>
            <div class="mb-7">
              <div class="chekt-select-option-wrapper" #countrySelectDropdown>
                <div class="chekt-select-option" style="z-index:2">
                  <div class="chekt-select-option-label" (click)="toggleCountryList()">
                    <div *ngIf="!newCardInfo.country" style="color:#a3acb9;">Select the country</div>
                    <div>{{newCardInfo.country.name}}</div>
                  </div>
                  <div class="chekt-select-option-icon">
                    <div class="my-icon" style="font-size: 18px;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                        <path d="M0 0h24v24H0V0z" fill="none"></path>
                        <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="chekt-select-dropdown" *ngIf="isUnfoldCountryList">
                  <input class="search-input" type="text" [(ngModel)]="countryFilterTxt" (keyup)="filterCountries()" placeholder="search"/>
                  <div class="chekt-select-search-nomatch" *ngIf="!filteredCountries.length">No match</div>
                  <div class="select-option-modal-list" *ngIf="filteredCountries.length">
                    <div class="chekt-select-dropdown-list" *ngFor="let country of filteredCountries" (click)="selectCountry(country)">
                      <div>{{country.name}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-7">
              <input autocomplete="off" type="text" [(ngModel)]="newCardInfo.address1" (input)="onInputAddress()" placeholder="Address"/>
            </div>
            <div class="mb-7">
              <input autocomplete="off" type="text" [(ngModel)]="newCardInfo.address2" (input)="onInputAddressDetail()" placeholder="suite # (optional)"/>
            </div>
            <div class="mb-7">
              <input autocomplete="off" type="text" [(ngModel)]="newCardInfo.city" (input)="onInputCity()" placeholder="City"/>
            </div>
            <div class="mb-7">
              <div class="chekt-select-option-wrapper" #stateSelectDropdown>
                <div class="chekt-select-option" style="z-index:2">
                  <div class="chekt-select-option-label" (click)="isUnfoldStateList = !isUnfoldStateList">
                    <div *ngIf="!newCardInfo.state" style="color:#a3acb9;">Select the State</div>
                    <div *ngIf="newCardInfo.state">{{newCardInfo.state}}</div>
                  </div>
                  <div class="chekt-select-option-icon">
                    <div class="my-icon" style="font-size: 18px;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                        <path d="M0 0h24v24H0V0z" fill="none"></path>
                        <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="chekt-select-dropdown" *ngIf="isUnfoldStateList">
                  <div class="select-option-modal-list" *ngIf="states.length">
                    <div class="chekt-select-dropdown-list" *ngFor="let state of states" (click)="selectState(state)">
                      <div>{{state.name}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-7">
              <input autocomplete="off" type="text" [(ngModel)]="newCardInfo.zipcode" (input)="onInputZipcode()" placeholder="zip code"/>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="cardAccounts.length && !isCreatingCreditCardAccount">
        <div class="mb-7">Your Payment Accounts</div>
        <div class="chekt-select-option-wrapper" #registeredCardAccountSelectDropdown>
          <div class="chekt-select-option" style="z-index:2">
            <div class="chekt-select-option-label" (click)="isUnfoldCardAccountList = !isUnfoldCardAccountList">
              <div *ngIf="!selectedForCustomerCardAccount">Select payment Account</div>
              <div *ngIf="selectedForCustomerCardAccount">
                <app-card-account [card]="selectedForCustomerCardAccount" [defaultPaymentId]="defaultPaymentId"></app-card-account>
              </div>
            </div>
            <div class="chekt-select-option-icon">
              <div class="my-icon" style="font-size: 18px;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                  <path d="M0 0h24v24H0V0z" fill="none"></path>
                  <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="chekt-select-dropdown" *ngIf="isUnfoldCardAccountList">
            <div class="select-option-modal-list">
              <div class="chekt-select-dropdown-list" *ngFor="let card of cardAccounts" (click)="selectCardAccountList(card)">
                <app-card-account [card]="card" [defaultPaymentId]="defaultPaymentId"></app-card-account>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="paymentMethod === 'ACH Bank Accounts'">
      <ng-container *ngIf="!bankAccounts.length">
        <div class="item">
          <div class="mb-7">Account holder type</div>
          <div class="chekt-select-option-wrapper" #bankTypeSelectDropdown>
            <div class="chekt-select-option" style="z-index:2">
              <div class="chekt-select-option-label" (click)="isUnfoldBankTypeSelectList = !isUnfoldBankTypeSelectList">
                <div>{{newBankAccount.account_holder_type}}</div>
              </div>
              <div class="chekt-select-option-icon">
                <div class="my-icon" style="font-size: 18px;">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                    <path d="M0 0h24v24H0V0z" fill="none"></path>
                    <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div class="chekt-select-dropdown" *ngIf="isUnfoldBankTypeSelectList">
              <div class="select-option-modal-list">
                <div class="chekt-select-dropdown-list" *ngFor="let selType of accountHolderTypes" (click)="selectType(selType)">
                  <div>{{selType}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="mb-7">Account holder name</div>
          <div>
            <input autocomplete="off" type="text" placeholder="" [(ngModel)]="newBankAccount.account_holder_name" (input)="onInputHolderName()"/>
          </div>
        </div>
        <div class="item">
          <div class="mb-7 flex"><span class="mr-7">Routing number</span>
            <div class="tooltip-content v-center">
              <comp-icon class="pointer" [icon]="'info'" [size]="18"></comp-icon>
              <div class="tooltip">
                <div class="bank-card mb-10">
                  <div class="bank-card-area">
                    <div class="flex v-center">
                      <comp-icon class="mr-10" [icon]="'account_balance'" [size]="18" [color]="'hsla(0,0%,0%,0.2)'"></comp-icon>
                      <div>BANK</div>
                    </div>
                    <div class="mv-4">
                      <div class="font-10">PAY TO THE ORDER OF</div>
                    </div>
                    <div class="flex v-center mb-10">
                      <comp-icon class="mr-7" [icon]="'dollar'" [size]="18" [color]="'hsla(0,0%,0%,0.2)'"></comp-icon>
                      <div class="input-box"></div>
                    </div>
                    <div class="split-line mb-7"></div>
                    <div>
                      <div class="font-10 mb-7">MEMO</div>
                    </div>
                    <div class="split-line mb-10"></div>
                    <div class="flex">
                      <div class="account-number relative mr-10">
                        <div class="highlight">123456789</div>
                        <div class="indicator">
                          <div class="horiz-line"></div>
                          <div class="vertical-line"></div>
                        </div>
                      </div>
                      <div class="mr-10">000123456789</div>
                      <div>1234</div>
                    </div>
                  </div>
                </div>
                <div>Your routing number is normally found on a check provided by your bank.</div>
              </div>
            </div>
          </div>
          <div>
            <input autocomplete="off" type="text" placeholder="110000000" [class.invalid]="bankErrorString.routing_number" [(ngModel)]="newBankAccount.routing_number" (input)="onInputRoutingNumber()"/>
            <div class="error" *ngIf="bankErrorString.routing_number">{{bankErrorString.routing_number}}</div>
          </div>
        </div>
        <div class="item">
          <div class="mb-7 flex"><span class="mr-7">Account number</span>
            <div class="tooltip-content v-center">
              <comp-icon class="pointer" [icon]="'info'" [size]="18"></comp-icon>
              <div class="tooltip">
                <div class="bank-card mb-10">
                  <div class="bank-card-area">
                    <div class="flex v-center">
                      <comp-icon class="mr-10" [icon]="'account_balance'" [size]="18" [color]="'hsla(0,0%,0%,0.2)'"></comp-icon>
                      <div>BANK</div>
                    </div>
                    <div class="mv-4">
                      <div class="font-10">PAY TO THE ORDER OF</div>
                    </div>
                    <div class="flex v-center mb-10">
                      <comp-icon class="mr-7" [icon]="'dollar'" [size]="18" [color]="'hsla(0,0%,0%,0.2)'"></comp-icon>
                      <div class="input-box"></div>
                    </div>
                    <div class="split-line mb-7"></div>
                    <div>
                      <div class="font-10 mb-7">MEMO</div>
                    </div>
                    <div class="split-line mb-10"></div>
                    <div class="account-number flex">
                      <div class="mr-10">123456789</div>
                      <div class="relative mr-10">
                        <div class="highlight">000123456789</div>
                        <div class="indicator">
                          <div class="horiz-line"></div>
                          <div class="vertical-line"></div>
                        </div>
                      </div>
                      <div>1234</div>
                    </div>
                  </div>
                </div>
                <div>Your account number is normally found on a check provided by your bank.</div>
              </div>
            </div>
          </div>
          <div>
            <input autocomplete="off" type="text" placeholder="000123456789" pattern="^[a-zA-Z0-9]+$" [(ngModel)]="newBankAccount.account_number" (keyup)="diffAccountNumber()" (input)="onInputAccountNumber()" [class.invalid]="!isValidAccountNumber"/>
            <div class="error" *ngIf="bankErrorString.account_number">{{bankErrorString.account_number}}</div>
          </div>
        </div>
        <div class="item">
          <div class="mb-7">Confirm account number</div>
          <div>
            <input autocomplete="off" type="text" placeholder="000123456789" pattern="[A-Za-z0-9]" [(ngModel)]="newBankAccount.confirm_account_number" (keyup)="diffAccountNumber()" (keypress)="checkString($event)" (input)="validateBankAccount()" [class.invalid]="!isValidAccountNumber"/>
            <div class="error" *ngIf="!isValidAccountNumber">Please filled correct account number</div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="bankAccounts.length">
        <div class="mb-7">Your Payment Accounts</div>
        <div class="chekt-select-option-wrapper" #registeredBankAccountSelectDropdown>
          <div class="chekt-select-option" style="z-index:2">
            <div class="chekt-select-option-label" (click)="isUnfoldBankAccountList = !isUnfoldBankAccountList">
              <div *ngIf="!selectedForCustomerBankAccount" style="color:#8792A2">Select payment Account</div>
              <div *ngIf="selectedForCustomerBankAccount">
                <app-bank-account [bank]="selectedForCustomerBankAccount" [defaultPaymentId]="defaultPaymentId"></app-bank-account>
              </div>
            </div>
            <div class="chekt-select-option-icon">
              <div class="my-icon" style="font-size: 18px;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                  <path d="M0 0h24v24H0V0z" fill="none"></path>
                  <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="chekt-select-dropdown" *ngIf="isUnfoldBankAccountList">
            <div class="select-option-modal-list" *ngIf="!bankAccounts.length">
              <div class="chekt-select-dropdown-list">No registered Bank Account</div>
            </div>
            <div class="select-option-modal-list" *ngIf="bankAccounts.length">
              <div class="chekt-select-dropdown-list" *ngFor="let bank of bankAccounts" (click)="selectBankAccountList(bank)">
                <app-bank-account [bank]="bank" [defaultPaymentId]="defaultPaymentId"></app-bank-account>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="paymentMethod === 'SEPA'">
      <ng-container *ngIf="!sepaAccounts.length">
        <div class="item">
          <div class="mb-7">Name</div>
          <div>
            <input autocomplete="off" type="text" placeholder="Name" [(ngModel)]="newSEPAAccount.name" (input)="onInputSEPAName()"/>
          </div>
        </div>
        <div class="item">
          <div class="mb-7">Email</div>
          <div>
            <input autocomplete="off" type="email" placeholder="john.doh@example.com" [(ngModel)]="newSEPAAccount.email" (input)="onInputSEPAEmail()"/>
            <div class="error" *ngIf="!isValidEmail">Invalid email format</div>
          </div>
        </div>
        <div class="item">
          <div class="mb-7">IBAN</div>
          <div>
            <input autocomplete="off" type="text" placeholder="DE00 0000 0000 0000 0000 00" required="required" pattern="(d{4}s?){4}" [(ngModel)]="newSEPAAccount.iban" (input)="onInputIBAN()" (keyup)="formatingIBAN($event.target.value, $event.keyCode)"/>
            <div class="error" *ngIf="!isValidIBAN && newSEPAAccount.iban">The IBAN is not valid. Please check again.</div>
          </div>
        </div>
        <div class="item" style="line-height: 20px">
          By providing your IBAN and confirming this payment, you authorise (A) Rocketship Inc. and Stripe, our payment service provider, 
          to send instructions to your bank to debit your account and 
          (B) your bank to debit your account in accordance with those instructions. 
          You are entitled to a refund from your bank under the terms and conditions of 
          your agreement with your bank. A refund must be claimed within 8 weeks starting 
          from the date on which your account was debited.
        </div>
      </ng-container>
      <ng-container *ngIf="sepaAccounts.length">
        <div class="mb-7">Your Payment Accounts</div>
        <div class="chekt-select-option-wrapper" #registeredSEPAAccountSelectDropdown>
          <div class="chekt-select-option" style="z-index:2">
            <div class="chekt-select-option-label" (click)="isUnfoldSEPAAccountList = !isUnfoldSEPAAccountList">
              <div *ngIf="!selectedForCustomerSEPAAccount" style="color:#8792A2">Select payment Account</div>
              <div *ngIf="selectedForCustomerSEPAAccount">
                <app-sepa-account [sepa]="selectedForCustomerSEPAAccount" [defaultPaymentId]="defaultPaymentId"></app-sepa-account>
              </div>
            </div>
            <div class="chekt-select-option-icon">
              <div class="my-icon" style="font-size: 18px;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                  <path d="M0 0h24v24H0V0z" fill="none"></path>
                  <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="chekt-select-dropdown" *ngIf="isUnfoldSEPAAccountList">
            <div class="select-option-modal-list" *ngIf="!sepaAccounts?.length">
              <div class="chekt-select-dropdown-list">No registered SEPA Account</div>
            </div>
            <div class="select-option-modal-list" *ngIf="sepaAccounts?.length">
              <div class="chekt-select-dropdown-list" *ngFor="let sepa of sepaAccounts" (click)="selectSEPAAccountList(sepa)">
                <app-sepa-account [sepa]="sepa" [defaultPaymentId]="defaultPaymentId"></app-sepa-account>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<dealer-warning [modal]="m_warning"></dealer-warning>